export enum DataTableRowColor {
  Default,
  Warn,
  Active
}
